// Scripts/ToolsHub.js
// منسّق الأدوات (نسخة محسنة):
// - يضمن بقاء أداة واحدة "تفاعلية" فعالة (مثل القياس أو الرسم أو الاستعلام).
// - يسمح ببقاء أداة الاستعلام (Identify) فعالة عند فتح القوائم الجانبية (مثل الطبقات).

(function () {
  // الأدوات التفاعلية (Exclusive)
  const EXCLUSIVE_TOOLS = ['measure', 'draw', 'gpsTool', 'btnOpenRouting', 'identifyToggleBtn'];
  // الأدوات الجانبية/المساعدة (Utilities) - لا تغلق الاستعلام عند فتحها
  const UTILITY_TOOLS = ['layers', 'shareBtn'];
  const GPS_TOOLS = ['goToCoordinatesBtn'];
  const TOOLS = [...EXCLUSIVE_TOOLS, ...UTILITY_TOOLS, ...GPS_TOOLS];

  // مساعدات
  const $btn = (id) => $('#' + id);
  const isActive = (id) => $btn(id).hasClass('active');

  function forceClose(id) {
    if (!isActive(id)) return;
    $(document).trigger('tool:cleanup', { id });
    $btn(id).trigger('click');
  }

  // أغلق كل الأدوات ما عدا المحدّدة (مع استثناءات ذكية)
  function closeAllExcept(exceptId) {
    TOOLS.forEach((id) => {
      if (id === exceptId || !isActive(id)) return;

      // قاعدة 1: إذا فتحنا أداة مساعدة (مثل الطبقات)، لا نغلق أداة الاستعلام
      if (UTILITY_TOOLS.includes(exceptId) && id === 'identifyToggleBtn') return;

      // قاعدة 2: إذا فعلنا الاستعلام، لا نغلق الأدوات المساعدة المفتوحة أصلاً
      if (exceptId === 'identifyToggleBtn' && UTILITY_TOOLS.includes(id)) return;

      // قاعدة 3: السماح ببقاء الـ GPS نشطاً (بدون تتبع) عند الرسم أو القياس أو الاستعلام أو أي أداة أخرى
      // الـ GPS أداة مساعدة دائمة لا يجب إغلاقها تلقائياً
      if (id === 'goToCoordinatesBtn') return;
      
      // قاعدة 4: إذا تم تشغيل الـ GPS، لا نغلق الاستعلام
      if (exceptId === 'goToCoordinatesBtn' && id === 'identifyToggleBtn') return;

      forceClose(id);
    });
  }

  // فعّل أداة واحدة حصراً - مع مانع تزاحم (Debounce)
  let toolTimeout = null;
  function activateTool(id) {
    if (toolTimeout) return;
    closeAllExcept(id);
    if (!isActive(id)) $btn(id).trigger('click');
    toolTimeout = setTimeout(() => { toolTimeout = null; }, 400);
  }

  // ===== ربط باستخدام Event Delegation (لتعمل مع الأزرار الديناميكية) =====
  $(document).on('pointerdown.toolsHub', TOOLS.map(id => '#' + id).join(','), function () {
    closeAllExcept(this.id);
  });

  // ===== Chips: الزر العائم لفتح الأداة (اسم النمط: #<tool>ShowChipBtn) =====
  $(document).on('click.toolsHub', TOOLS.map(id => '#' + id + 'ShowChipBtn').join(','), function (e) {
    e.preventDefault();
    const toolId = this.id.replace('ShowChipBtn', '');
    activateTool(toolId);
  });

  // API اختياري
  window.ToolsHub = { activateTool, closeAllExcept, forceClose, isActive };
})();
